import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'

export class ModalButtonData {
	constructor(label, onClick, type = ButtonType.Default, size = ButtonSize.Default, isLoading = false)
	{
		this.label = label
		this.onClick = onClick
		this.type = type
		this.size = size
		this.isLoading = isLoading
	}
}